import { API_HOST } from './config'
export default {
  // ADMIN ROUTES
  ADMIN_CONTENTS: `${API_HOST}admin/content/all_content`,
  ADMIN_ADD_CONTENT: `${API_HOST}admin/content/add_content`,
  ADMIN_EDIT_CONTENT: `${API_HOST}admin/content/edit_content`,
  ADMIN_DELETE_CONTENT: `${API_HOST}admin/content/delete_content`
}